import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import BackHomeButton from "./components/BackHomeButton";
import RequireNickname from "./components/RequireNickname";
import LaunchAnnouncementModal from "./components/LaunchAnnouncementModal";
import { useAuth } from "./contexts/AuthContext";
import AuthCallback from "./pages/AuthCallback";
import Profile from "./pages/Profile";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ChallengeDetail from "./pages/ChallengeDetail";
import CheckoutReturn from "./pages/CheckoutReturn";
import PlayCode from "./pages/PlayCode";
import PlaySession from "./pages/PlaySession";
import Leaderboard from "./pages/Leaderboard";
import MyCodes from "./pages/MyCodes";
import MyQualifications from "./pages/MyQualifications";
import BuyCodes from "./pages/BuyCodes";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCodes from "./pages/admin/AdminCodes";
import AdminPrizeClaims from "./pages/admin/AdminPrizeClaims";
import AdminLiveEvents, { AdminLiveConsole, LiveScreen, LiveJoin, LivePlay } from "./pages/live/LiveEvents";
import ChallengeEditor from "./pages/admin/ChallengeEditor";
import CGU from "./pages/legal/CGU";
import CGV from "./pages/legal/CGV";
import Reglement from "./pages/legal/Reglement";
import Confidentialite from "./pages/legal/Confidentialite";
import Cookies from "./pages/legal/Cookies";
import MentionsLegales from "./pages/legal/MentionsLegales";
import Contact from "./pages/legal/Contact";
import DonneesPersonnelles from "./pages/legal/DonneesPersonnelles";
import ChallengeAdminView from "./pages/admin/ChallengeAdminView";
import AdminChallengeQualifications from "./pages/admin/AdminChallengeQualifications";

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback fragment SYNCHRONOUSLY during render so
  // we exchange the session_id BEFORE AuthProvider tries to hit /auth/me.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <BackHomeButton />
      <RequireNickname />
      <LaunchAnnouncementGate />
      <Routes>
      {/* Public */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/challenges/:id" element={<ChallengeDetail />} />
      <Route path="/checkout/return" element={<CheckoutReturn />} />
      <Route path="/play" element={<PlayCode />} />
      <Route path="/play/session/:sessionId" element={<PlaySession />} />
      <Route path="/leaderboard/:id" element={<Leaderboard />} />
      <Route path="/mes-codes" element={<MyCodes />} />
      <Route path="/mes-qualifications" element={<MyQualifications />} />
      <Route path="/acheter" element={<BuyCodes />} />
      <Route path="/cgu" element={<CGU />} />
      <Route path="/cgv" element={<CGV />} />
      <Route path="/reglement" element={<Reglement />} />
      <Route path="/confidentialite" element={<Confidentialite />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/mentions-legales" element={<MentionsLegales />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/donnees-personnelles" element={<DonneesPersonnelles />} />

      {/* Admin */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/codes"
        element={
          <ProtectedRoute adminOnly>
            <AdminCodes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/prize-claims"
        element={
          <ProtectedRoute adminOnly>
            <AdminPrizeClaims />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/live-events"
        element={
          <ProtectedRoute adminOnly>
            <AdminLiveEvents />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/live-events/:id"
        element={
          <ProtectedRoute adminOnly>
            <AdminLiveConsole />
          </ProtectedRoute>
        }
      />
      <Route path="/live" element={<LiveJoin />} />
      <Route path="/live/:code" element={<LiveJoin />} />
      <Route path="/live/:code/play" element={<LivePlay />} />
      <Route path="/live/:code/screen" element={<LiveScreen />} />
      <Route
        path="/admin/challenges/new"
        element={
          <ProtectedRoute adminOnly>
            <ChallengeEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/challenges/:id/edit"
        element={
          <ProtectedRoute adminOnly>
            <ChallengeEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/challenges/:id"
        element={
          <ProtectedRoute adminOnly>
            <ChallengeAdminView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/challenges/:id/qualifications"
        element={
          <ProtectedRoute adminOnly>
            <AdminChallengeQualifications />
          </ProtectedRoute>
        }
      />
      <Route path="/dashboard" element={<Navigate to="/admin" replace />} />
    </Routes>
    </>
  );
}

function LaunchAnnouncementGate() {
  const { user } = useAuth();
  return <LaunchAnnouncementModal user={user} />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "rgba(10,10,22,0.85)",
            border: "1px solid rgba(0,229,255,0.35)",
            color: "white",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </AuthProvider>
  );
}
